import axios from "axios";

//for local use

const api = axios.create({
  baseURL: "http://localhost:5000/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// const api = axios.create({
//   baseURL: "http://192.168.1.7:5000/api",
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

export const submitContact = async (contactData) => {
  try {
    const response = await api.post("/contact", contactData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
